export type MetricIconType = "development" | "population" | "fortress" | "treasury";

export const metricIconPaths: Record<MetricIconType, string> = {
  development: "/assets/metrics/development.png",
  population: "/assets/metrics/population.png",
  fortress: "/assets/metrics/fortress.png",
  treasury: "/assets/metrics/treasury.png",
};

export function MetricIcon({
  metric,
  className = "",
}: {
  metric: MetricIconType;
  className?: string;
}) {
  return (
    <img
      className={`metric-icon ${className}`.trim()}
      src={metricIconPaths[metric]}
      alt=""
      aria-hidden="true"
      draggable={false}
    />
  );
}
